import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import PageLayout from '../components/layout/PageLayout';
import useConversations from '../hooks/useConversations';
import ConversationList from '../components/messaging/ConversationList';

function MessagesPage() {
  const navigate = useNavigate();
  const { user, isAuthenticated } = useAuth();
  const { conversations, loading, error } = useConversations();

  useEffect(() => {
    if (!isAuthenticated) {
      navigate('/?auth=login');
    }
  }, [isAuthenticated, navigate]);

  if (!isAuthenticated) {
    return null;
  }

  return (
    <PageLayout title="Messages">
      <div className="max-w-2xl mx-auto mt-6 bg-white rounded-lg shadow min-h-[400px]">
        <div className="px-4 py-3 border-b border-gray-200">
          <h1 className="text-xl font-semibold text-gray-900">Messages</h1>
        </div>
        {error ? (
          <div className="px-4 py-2 bg-red-50 text-red-700 text-sm">{error}</div>
        ) : null}
        <ConversationList
          conversations={conversations}
          currentUserId={user?.id}
          loading={loading}
          onConversationClick={(conv) => navigate('/messages/' + conv.id)}
        />
      </div>
    </PageLayout>
  );
}

export default MessagesPage;
